import { apiCall } from './gqlClient';

const GETADDONS_QUERY = `
  query getAddOns {
    getAddOns
    {
      id
			key
			name
			description
			billing
			stripePriceId
			requiresMinPlan
			active
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const getAddOnsApiCall = async (fragments = null) => apiCall({ query: GETADDONS_QUERY, variables: {}, fragments });

const GETPROVIDERADDONS_QUERY = `
  query getProviderAddOns($providerId: Int!) {
    getProviderAddOns(providerId: $providerId)
    {
      id
			providerId
			addOnId
			status
			quantity
			purchasedAt
			expiresAt
      ...fragments
    }
  }`;

export const getProviderAddOnsApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPROVIDERADDONS_QUERY, variables: {providerId}, fragments });

const UPSERTADDON_QUERY = `
  mutation upsertAddOn($request: AddOnInput!) {
    upsertAddOn(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const upsertAddOnApiCall = async ({request}, fragments = null) => apiCall({ query: UPSERTADDON_QUERY, variables: {request}, fragments });

const SETADDONACTIVE_QUERY = `
  mutation setAddOnActive($id: Int!, $active: Boolean!) {
    setAddOnActive(id: $id, active: $active)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const setAddOnActiveApiCall = async ({id, active}, fragments = null) => apiCall({ query: SETADDONACTIVE_QUERY, variables: {id, active}, fragments });

const DELETEADDON_QUERY = `
  mutation deleteAddOn($id: Int!) {
    deleteAddOn(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteAddOnApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEADDON_QUERY, variables: {id}, fragments });

const GRANTPROVIDERADDON_QUERY = `
  mutation grantProviderAddOn($providerId: Int!, $addOnId: Int!, $quantity: Int, $expiresAt: DateTime) {
    grantProviderAddOn(providerId: $providerId, addOnId: $addOnId, quantity: $quantity, expiresAt: $expiresAt)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const grantProviderAddOnApiCall = async ({providerId, addOnId, quantity, expiresAt}, fragments = null) => apiCall({ query: GRANTPROVIDERADDON_QUERY, variables: {providerId, addOnId, quantity, expiresAt}, fragments });

const REVOKEPROVIDERADDON_QUERY = `
  mutation revokeProviderAddOn($id: Int!) {
    revokeProviderAddOn(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const revokeProviderAddOnApiCall = async ({id}, fragments = null) => apiCall({ query: REVOKEPROVIDERADDON_QUERY, variables: {id}, fragments });

const SETADDONGRANT_QUERY = `
  mutation setAddOnGrant($addOnId: Int!, $featureKey: String!, $grantValue: JSON!) {
    setAddOnGrant(addOnId: $addOnId, featureKey: $featureKey, grantValue: $grantValue)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const setAddOnGrantApiCall = async ({addOnId, featureKey, grantValue}, fragments = null) => apiCall({ query: SETADDONGRANT_QUERY, variables: {addOnId, featureKey, grantValue}, fragments });

const REMOVEADDONGRANT_QUERY = `
  mutation removeAddOnGrant($addOnId: Int!, $featureKey: String!) {
    removeAddOnGrant(addOnId: $addOnId, featureKey: $featureKey)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const removeAddOnGrantApiCall = async ({addOnId, featureKey}, fragments = null) => apiCall({ query: REMOVEADDONGRANT_QUERY, variables: {addOnId, featureKey}, fragments });
